import React, { useState } from 'react';
import { Button, Input, message, Modal } from 'antd';
import { Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
const { TextArea } = Input;

const json2csv = (objArray) => {
    if (!objArray) {
        return null;
	}

    const data = [Object.keys(objArray[0])].concat(objArray);

    return data.map(it => {
		return Object.values(it).join('\t');
    }).join('\n');
};

// Needs to be added before Search Panel and after Toolbar
const CopyTableDataToClipboard = ({tableDataAsList}) => {
	const [ messageApi, contextHolder ] = message.useMessage();
	const [ modalVisible, setModalVisible ] = useState(false);
	const [ modalText, setModalText ] = useState('');
	const handleModalOk = () => {
		setModalVisible(false);
		setModalText('');
	};
	const handleCancel = () => {
		setModalVisible(false);
		setModalText('');
	};
    const updateExportData = () => {
        const csvData = json2csv(tableDataAsList);
        if (!csvData) {
            messageApi.error('Could not copy text to clipboard');
            return;
        }

		/** 
			Current problem: this is returning undefined because the Clipboard API is only avaliable over https. Thier live portal is currently being hosted on http. If they ever move it to https we will no longer need the fallback solution.
		**/
		if(navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(csvData).then(() => {
				console.log('Copying to clipboard was successful!');
				messageApi.success('Copying to clipboard was successful!');
			}, (err) => {
				console.error('Could not copy text: ', err);
				messageApi.error('Could not copy text to clipboard');
			});
		} else {
			//Fallback for HTTP or any unsupported browsers
			setModalText(csvData);
			setModalVisible(true);
		}
    };

    
    return (
        <Template
            name="toolbarContent"
        >
			{contextHolder}
            <Button
                disabled={tableDataAsList.length === 0 }
                onClick={updateExportData}
            >
                Copy to Clipboard
            </Button>
			<Modal 
				title="CSV Data"
				open={modalVisible}
				onOk={handleModalOk}
				onCancel={handleCancel}
				width="75%"
				bodyStyle={{ height: '500px' }}
				style={{ top: '20px' }}
			>
			<TextArea value={modalText} rows={22} />
			</Modal>
            <TemplatePlaceholder/>
            <TemplatePlaceholder/>
        </Template>
    );
};

export default CopyTableDataToClipboard;
